import * as types from '../mutation-types'

export const transactionsPageSize = 20
export const packagesPageSize = 20

export const mutations = {
  [types.SET_GETTING_TRANSACTIONS] (state, incr) {
    state.gettingTransactions += incr
  },
  [types.CLEAR_TRANSACTIONS] (state) {
    state.allTransactions = []
    state.transactionsCount = undefined
    state.currentPage = undefined
  },
  [types.RECEIVE_FIRST_TRANSACTIONS] (state, params) {
    state.allTransactions = params.transactions
    state.transactionsCount = params.transactionsCount
    state.currentPage = 1
  },
  [types.RECEIVE_NEXT_TRANSACTIONS] (state, params) {
    state.allTransactions = state.allTransactions.concat(params.transactions)
    state.currentPage = params.page
  },
  [types.SET_CURRENT_REPO] (state, desiredRepoId) {
    state.allTransactions = []
    state.transactionsCount = undefined
    state.currentPage = undefined
  },
  [types.SET_GETTING_TRANSACTION_DETAILS] (state, transactionId) {
    if (state.gettingTransactionDetails.find(t => { return t === transactionId })) {
      return
    }
    state.gettingTransactionDetails.push(transactionId)
  },
  [types.CLEAR_GETTING_TRANSACTION_DETAILS] (state, transactionId) {
    const i = state.gettingTransactionDetails.findIndex(t => { return t === transactionId })
    if (i !== -1) {
      state.gettingTransactionDetails.splice(i, 1)
    }
  },
  [types.RECEIVE_TRANSACTION_DETAILS] (state, params) {
    const ti = state.allTransactions.findIndex(t => { return t.id === params.transactionDetails.transaction_id })
    if (ti !== -1) {
      const newTransaction = Object.assign({}, state.allTransactions[ti], params)
      state.allTransactions.splice(ti, 1, newTransaction)
    }
  },
  [types.SET_GETTING_TRANSACTION_PACKAGES] (state, transactionId) {
    if (state.gettingTransactionPackages.find(t => { return t === transactionId })) {
      return
    }
    state.gettingTransactionPackages.push(transactionId)
  },
  [types.CLEAR_GETTING_TRANSACTION_PACKAGES] (state, transactionId) {
    const i = state.gettingTransactionPackages.findIndex(t => { return t === transactionId })
    if (i !== -1) {
      state.gettingTransactionPackages.splice(i, 1)
    }
  },
  [types.RECEIVE_FIRST_TRANSACTION_PACKAGES] (state, params) {
    const ti = state.allTransactions.findIndex(t => { return t.id === params.transaction_id })
    if (ti !== -1) {
      const newTransaction = Object.assign({}, state.allTransactions[ti])
      newTransaction.packages = params.packages
      newTransaction.packagesCount = params.packagesCount
      newTransaction.packagesCurrentPage = 1
      state.allTransactions.splice(ti, 1, newTransaction)
    }
  },
  [types.RECEIVE_NEXT_TRANSACTION_PACKAGES] (state, params) {
    const ti = state.allTransactions.findIndex(t => { return t.id === params.transaction_id })
    if (ti !== -1) {
      const newTransaction = Object.assign({}, state.allTransactions[ti])
      newTransaction.packages = newTransaction.packages.concat(params.packages)
      newTransaction.packagesCurrentPage = params.page
      state.allTransactions.splice(ti, 1, newTransaction)
    }
  },
  [types.SET_GETTING_TRANSACTION_DATES] (state, flag) {
    state.gettingTransactionDates = flag
  },
  [types.CLEAR_TRANSACTION_DATES] (state) {
    state.transactionDates = {}
  },
  [types.RECEIVE_TRANSACTION_DATES] (state, transactionDates) {
    state.transactionDates = transactionDates
  },
  [types.SET_GETTING_REPO_MIN_TX_DATE] (state, flag) {
    state.gettingRepoMinTxDate = flag
    if (flag) {
      state.repoMinTxDate = undefined
    }
  },
  [types.RECEIVE_REPO_MIN_TX_DATE] (state, { data }) {
    if (data) {
      state.repoMinTxDate = data.min_date
      state.gettingRepoMinTxDate = false
    }
  },
}

const module = HTTP => ({

  state: {
    gettingTransactions: 0,
    allTransactions: [],
    transactionsCount: undefined,
    currentPage: undefined,
    gettingTransactionDetails: [],
    gettingTransactionPackages: [],
    gettingTransactionDates: false,
    repoMinTxDate: undefined,
    gettingRepoMinTxDate: false,
    transactionDates: {},
  },
  mutations,
  actions: {
    async getFirstTransactions ({ commit, rootState }, params) {
      try {
        commit(types.SET_GETTING_TRANSACTIONS, 1)
        commit(types.CLEAR_TRANSACTIONS)
        const response = await HTTP.get(`/sources/${params.sourceId}/transactions?_sort=created&_order=desc&_page=1&_limit=${transactionsPageSize}`)
        const transactions = response.data
        if (rootState.repos.currentRepoSource === params.sourceId) {
          commit(types.RECEIVE_FIRST_TRANSACTIONS, { transactions: transactions, transactionsCount: +response.headers['x-total-count'] })
        }
        commit(types.SET_GETTING_TRANSACTIONS, -1)
      } catch (e) {
        commit(types.SET_GETTING_TRANSACTIONS, -1)
        console.log(e)
      }
    },
    async getNextTransactions ({ commit, state, rootState }, params) {
      try {
        commit(types.SET_GETTING_TRANSACTIONS, 1)
        const page = state.currentPage + 1
        const response = await HTTP.get(`/sources/${params.sourceId}/transactions?_sort=created&_order=desc&_page=${page}&_limit=${transactionsPageSize}`)
        const transactions = response.data
        if (rootState.repos.currentRepoSource === params.sourceId) {
          commit(types.RECEIVE_NEXT_TRANSACTIONS, { transactions: transactions, page: page })
        }
        commit(types.SET_GETTING_TRANSACTIONS, -1)
      } catch (e) {
        commit(types.SET_GETTING_TRANSACTIONS, -1)
        console.log(e)
      }
    },
    async getTransactionDetails ({ commit, state }, params) {
      try {
        commit(types.SET_GETTING_TRANSACTION_DETAILS, params.transactionId)
        const response = await HTTP.get(`/sources/${params.sourceId}/transaction-details?transaction_id=${params.transactionId}`)
        const transactionDetails = response.data.length ? response.data[0] : { transaction_id: params.transactionId, details: 'No details found', results: [] }
        commit(types.RECEIVE_TRANSACTION_DETAILS, { transactionDetails: transactionDetails })
        commit(types.CLEAR_GETTING_TRANSACTION_DETAILS, params.transactionId)
      } catch (e) {
        commit(types.CLEAR_GETTING_TRANSACTION_DETAILS, params.transactionId)
        console.log(e)
      }
    },
    async getFirstTransactionPackages ({ commit, state }, params) {
      try {
        commit(types.SET_GETTING_TRANSACTION_PACKAGES, params.transactionId)
        const response = await HTTP.get(`/transactions/${params.transactionId}/transaction-packages?&_sort=action,name&_order=asc,asc&_page=1&_limit=${packagesPageSize}`)
        const packages = response.data
        commit(types.RECEIVE_FIRST_TRANSACTION_PACKAGES, { transaction_id: params.transactionId, packages: packages, packagesCount: +response.headers['x-total-count'] })
        commit(types.CLEAR_GETTING_TRANSACTION_PACKAGES, params.transactionId)
      } catch (e) {
        commit(types.CLEAR_GETTING_TRANSACTION_PACKAGES, params.transactionId)
        console.log(e)
      }
    },
    async getNextTransactionPackages ({ commit, state }, params) {
      try {
        commit(types.SET_GETTING_TRANSACTION_PACKAGES, params.transactionId)
        const transaction = state.allTransactions.find(t => { return t.id === params.transactionId })
        const page = transaction.packagesCurrentPage + 1
        const response = await HTTP.get(`/transactions/${params.transactionId}/transaction-packages?_sort=action,name&_order=asc,asc&_page=${page}&_limit=${packagesPageSize}`)
        const packages = response.data
        commit(types.RECEIVE_NEXT_TRANSACTION_PACKAGES, { transaction_id: params.transactionId, packages: packages, page: page })
        commit(types.CLEAR_GETTING_TRANSACTION_PACKAGES, params.transactionId)
      } catch (e) {
        commit(types.CLEAR_GETTING_TRANSACTION_PACKAGES, params.transactionId)
        console.log(e)
      }
    },
    async getTransactionDates ({ commit, state, rootState }, params) {
      try {
        commit(types.SET_GETTING_TRANSACTION_DATES, true)
        commit(types.CLEAR_TRANSACTION_DATES)
        var paramString = `txId=${params.txIds[0]}`
        for (let i = 1; i < params.txIds.length; i++) {
          paramString += `&txID=${params.txIds[i]}`
        }
        const response = await HTTP.get(`/transactions/lookup-dates?${paramString}`)
        const transactions = response.data
        if (rootState.repos.currentRepoId === params.repoId) {
          commit(types.RECEIVE_TRANSACTION_DATES, transactions)
          commit(types.SET_GETTING_TRANSACTION_DATES, false)
        }
      } catch (e) {
        commit(types.SET_GETTING_TRANSACTION_DATES, false)
        console.log(e)
      }
    },
    async getRepoMinTxDate ({ commit }, params) {
      commit(types.SET_GETTING_REPO_MIN_TX_DATE, true)
      try {
        const response = await HTTP.get(`/repos/${params.repoId}/first-transaction`)
        const data = response.data
        commit(types.RECEIVE_REPO_MIN_TX_DATE, { data })
      } catch (e) {
        console.log(e)
      }
    },
  },
  getters: {},
})

export default {
  module,
}
